/**
 * Info: Zkoušeli jsme validaci rozšířit pomocí knihovny libphonenumber-js (je to přepis Google libphonenumber),
 * ale validace vracela true i pro takové číslo: isValidPhoneNumber('+420902111222', 'CZ')
 * Prozatím tudíž necháváme libphonenumber jen pro serverouvou validaci (alespoň nám nevzroste velikost JS bundle).
 */
export default function () {
	/**
	 * must be same as PHP functions
	 */
	Nette.validators.PhoneValidator_validator = (elem, args, val) => {
		let newVal = sanitizePhone(val);
		elem.value = newVal;

		const r1 = new RegExp(
			/(([+][0-9]{1,3}\s?)|(\d{5}\s?)|(\d{5}\s?))?((\d{10})|(\d{3}\s?\d{3}\s?\d{3})|(\d{3}\s?\d{2}\s?\d{2}\s?\d{2}))/g
		);
		return r1.test(newVal);
	};
}

/**
 * Odstraní všechny znaky kromě číslic, písmen a plus.
 * @param {string} phone
 * @returns {string}
 */
function sanitizePhone(phone) {
	return phone.replace(/[^0-9A-Za-z+]/g, '');
}
